import { render, staticRenderFns } from "./UpDeviceAlertWrap.vue?vue&type=template&id=28976cc4"
import script from "./UpDeviceAlertWrap.vue?vue&type=script&lang=js"
export * from "./UpDeviceAlertWrap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports